'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    padding: 20px;\n    border: 2px dashed ', ';\n    border-radius: 10px;\n    background-color: ', ';\n'], ['\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    padding: 20px;\n    border: 2px dashed ', ';\n    border-radius: 10px;\n    background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    overflow-y: auto;\n    padding: 0;\n'], ['\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n    overflow-y: auto;\n    padding: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    list-style: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    ', ';\n'], ['\n    list-style: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    display: flex;\n'], ['\n    display: flex;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    width: 50px;\n    height: 50px;\n    margin-right: 10px;\n    border-radius: 4px;\n    object-fit: cover;\n'], ['\n    width: 50px;\n    height: 50px;\n    margin-right: 10px;\n    border-radius: 4px;\n    object-fit: cover;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 900;\n    color: ', ';\n    margin-right: 10px;\n    border-radius: 4px;\n    background-color: ', ';\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    font-family: \'Poppins\', sans-serif;\n    font-size: 12px;\n    font-weight: 900;\n    color: ', ';\n    margin-right: 10px;\n    border-radius: 4px;\n    background-color: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    color: ', ';\n'], ['\n    color: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    margin: 0 5px;\n\n    &:hover {\n        opacity: 0.7;\n    }\n'], ['\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    margin: 0 5px;\n\n    &:hover {\n        opacity: 0.7;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _reactDropzone = require('react-dropzone');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _selectSession = require('../../selectors/context/selectSession');

var _colors = require('../../constants/colors');

var _alignments = require('../../constants/alignments');

var _primaryButton = require('../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

var _download = require('../../atoms/icons/download');

var _download2 = _interopRequireDefault(_download);

var _delete = require('../../atoms/icons/delete');

var _delete2 = _interopRequireDefault(_delete);

var _closeButton = require('../../atoms/buttons/closeButton');

var _closeButton2 = _interopRequireDefault(_closeButton);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _sizes = require('../../constants/sizes');

var _errorLabel = require('../../atoms/errorLabel');

var _errorLabel2 = _interopRequireDefault(_errorLabel);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DropzoneContainer = _styledComponents2.default.div(_templateObject, function (props) {
    return props.isDragActive ? props.config.accentColor : _colors.Colors.StrokeLight;
}, function (props) {
    return props.config.backgroundColor;
});

var FilesListContainer = _styledComponents2.default.ul(_templateObject2);

var FileItem = _styledComponents2.default.li(_templateObject3, function (props) {
    return props.isError ? 'border: 1px solid ' + _colors.Colors.Error : null;
});

var FileActionContainer = _styledComponents2.default.div(_templateObject4);

var ImageThumbnail = _styledComponents2.default.img(_templateObject5);

var PictureIcon = function PictureIcon() {
    return _react2.default.createElement(
        'svg',
        { width: '60',
            height: '50',
            viewBox: '0 0 60 50',
            fill: _colors.Colors.StrokeMedium,
            xmlns: 'http://www.w3.org/2000/svg'
        },
        _react2.default.createElement(
            'g',
            { transform: 'translate(6,7)' },
            _react2.default.createElement('path', { d: 'M8.68642 5.57368L10.0386 2.42943C10.6739 0.952091 12.0915 0 13.6557 0H24.3443C25.9085 0 27.3261 0.952091 27.9614 2.42943L29.3136 5.57368C29.5677 6.16462 30.1347 6.54545 30.7604 6.54545H34.0417C36.2278 6.54545 38 8.37702 38 10.6364V31.9091C38 34.1684 36.2278 36 34.0417 36H3.95833C1.77221 36 0 34.1684 0 31.9091V10.6364C0 8.37702 1.77221 6.54545 3.95833 6.54545H7.23955C7.86527 6.54545 8.43229 6.16462 8.68642 5.57368ZM19 29.8636C24.0281 29.8636 28.1042 25.651 28.1042 20.4545C28.1042 15.258 24.0281 11.0455 19 11.0455C13.9719 11.0455 9.89583 15.258 9.89583 20.4545C9.89583 25.651 13.9719 29.8636 19 29.8636ZM19 25.7727C16.158 25.7727 13.8542 23.3917 13.8542 20.4545C13.8542 17.5174 16.158 15.1364 19 15.1364C21.842 15.1364 24.1458 17.5174 24.1458 20.4545C24.1458 23.3917 21.842 25.7727 19 25.7727Z' })
        )
    );
};

var FileThumbnail = _styledComponents2.default.div(_templateObject6, function (props) {
    return props.config.backgroundColor;
}, _colors.Colors.StrokeMedium);

var StyledProgress = _styledComponents2.default.progress(_templateObject7, function (props) {
    return props.textColor;
});

var IconBase = _styledComponents2.default.div(_templateObject8);

var FileUploader = function FileUploader(_ref) {
    var _ref$config = _ref.config,
        config = _ref$config === undefined ? {} : _ref$config,
        initialFiles = _ref.initialFiles,
        onUploadStart = _ref.onUploadStart,
        _onUploadProgress = _ref.onUploadProgress,
        onUploadComplete = _ref.onUploadComplete,
        onUploadError = _ref.onUploadError,
        onUploadCancel = _ref.onUploadCancel,
        onFileDelete = _ref.onFileDelete,
        onFilesChange = _ref.onFilesChange,
        intl = _ref.intl,
        restProps = _objectWithoutProperties(_ref, ['config', 'initialFiles', 'onUploadStart', 'onUploadProgress', 'onUploadComplete', 'onUploadError', 'onUploadCancel', 'onFileDelete', 'onFilesChange', 'intl']);

    config = _extends({}, FileUploader.defaultProps.defaultConfig, config);

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        files = _useState2[0],
        setFiles = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        uploading = _useState4[0],
        setUploading = _useState4[1];

    var fileInputRef = (0, _react.useRef)(null);

    var defaultDropzoneText = intl.formatMessage({ id: 'FileUploader.dragAndDrop' });
    var defaultAddFileButtonText = intl.formatMessage({ id: 'FileUploader.addFile' });
    var defaultUploadButtonText = intl.formatMessage({ id: 'FileUploader.upload' });
    var defaultRemoveText = intl.formatMessage({ id: 'FileUploader.remove' });

    (0, _react.useEffect)(function () {
        if (initialFiles) {
            setFiles(function (currentFiles) {
                // Extract files from currentFiles that haven't been uploaded
                var unUploadedFiles = currentFiles.filter(function (file) {
                    return !file.fileUrl && file.progress < 100;
                });

                return [].concat(_toConsumableArray(initialFiles), _toConsumableArray(unUploadedFiles));
            });
        }
    }, [initialFiles]);

    var handleFiles = (0, _react.useCallback)(function (inputFiles) {
        var fileList = Array.isArray(inputFiles) ? inputFiles : Array.from(inputFiles);
        var newFiles = fileList.map(function (file) {
            return {
                fileName: file.name,
                contentType: file.type,
                data: file,
                progress: 0,
                cancelSource: _axios2.default.CancelToken.source()
            };
        });

        setFiles(function (prevFiles) {
            var updatedFiles = [].concat(_toConsumableArray(prevFiles), _toConsumableArray(newFiles));
            if (onFilesChange) onFilesChange(updatedFiles);
            return updatedFiles;
        });

        if (config.autoUpload) {
            handleUpload(newFiles);
        }
    }, [files, config.autoUpload, onFilesChange]);

    var _useDropzone = (0, _reactDropzone.useDropzone)({
        onDrop: handleFiles,
        accept: config.acceptedFileTypes,
        multiple: config.multiple,
        maxFiles: config.maxFiles,
        maxSize: config.maxSize
    }),
        getRootProps = _useDropzone.getRootProps,
        getInputProps = _useDropzone.getInputProps,
        isDragActive = _useDropzone.isDragActive;

    var handleAddFileClick = (0, _react.useCallback)(function (e) {
        e.stopPropagation();
        fileInputRef.current.click();
    }, []);

    var updateFileProgress = (0, _react.useCallback)(function (prevFiles, fileName, progress) {
        return prevFiles.map(function (file) {
            if (file.fileName === fileName) {
                return _extends({}, file, {
                    progress: progress
                });
            }
            return file;
        });
    }, []);

    var handleUpload = (0, _react.useCallback)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var filesToUpload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : files;
        var filesToActuallyUpload, uploadPromises, updatedFiles;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        filesToActuallyUpload = filesToUpload.filter(function (file) {
                            return !file.fileUrl && !file.hasError;
                        });

                        if (!(filesToActuallyUpload.length === 0)) {
                            _context2.next = 3;
                            break;
                        }

                        return _context2.abrupt('return');

                    case 3:

                        setUploading(true);

                        uploadPromises = filesToActuallyUpload.map(function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fileObj) {
                                var formData, response, updatedFile;
                                return regeneratorRuntime.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                formData = new FormData();

                                                formData.append('files', fileObj.data);

                                                if (onUploadStart) onUploadStart(fileObj);

                                                _context.prev = 3;
                                                _context.next = 6;
                                                return _axios2.default.post(config.uploadEndpoint, formData, {
                                                    headers: {
                                                        'Content-Type': 'multipart/form-data',
                                                        'Authorization': 'Bearer ' + restProps.session.authenticationToken.token
                                                    },
                                                    onUploadProgress: function onUploadProgress(progressEvent) {
                                                        var totalLength = void 0;
                                                        if (progressEvent.event.lengthComputable) {
                                                            totalLength = progressEvent.event.total;
                                                        } else if (progressEvent.event.target) {
                                                            totalLength = progressEvent.event.target.getResponseHeader('content-length') || progressEvent.event.target.getResponseHeader('x-decompressed-content-length');
                                                        } else {
                                                            totalLength = null;
                                                        }

                                                        if (totalLength) {
                                                            var progress = Math.round(progressEvent.event.loaded * 100 / totalLength);

                                                            setFiles(function (prevFiles) {
                                                                return updateFileProgress(prevFiles, fileObj.fileName, progress);
                                                            });

                                                            if (_onUploadProgress) {
                                                                _onUploadProgress(fileObj, progress);
                                                            }
                                                        }
                                                    },
                                                    cancelToken: fileObj.cancelSource.token
                                                });

                                            case 6:
                                                response = _context.sent;

                                                if (!(response.status === 200)) {
                                                    _context.next = 13;
                                                    break;
                                                }

                                                updatedFile = _extends({}, fileObj, {
                                                    fileUrl: response.data && response.data.fileUrl ? response.data.fileUrl : 'uploaded-file-url',
                                                    hasError: false
                                                });


                                                if (onUploadComplete) onUploadComplete(updatedFile);

                                                return _context.abrupt('return', updatedFile);

                                            case 13:
                                                if (onUploadError) onUploadError(_extends({}, fileObj, { hasError: true }));

                                                return _context.abrupt('return', _extends({}, fileObj, {
                                                    hasError: true
                                                }));

                                            case 15:
                                                _context.next = 27;
                                                break;

                                            case 17:
                                                _context.prev = 17;
                                                _context.t0 = _context['catch'](3);

                                                if (!_axios2.default.isCancel(_context.t0)) {
                                                    _context.next = 24;
                                                    break;
                                                }

                                                console.error('Canceled by user:', _context.t0);

                                                if (onUploadCancel) onUploadCancel(_extends({}, fileObj));
                                                _context.next = 27;
                                                break;

                                            case 24:
                                                console.error('Error uploading file:', _context.t0);

                                                if (onUploadError) onUploadError(_extends({}, fileObj, { hasError: true }), _context.t0);

                                                return _context.abrupt('return', _extends({}, fileObj, { hasError: true }));

                                            case 27:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, undefined, [[3, 17]]);
                            }));

                            return function (_x2) {
                                return _ref3.apply(this, arguments);
                            };
                        }());
                        _context2.next = 7;
                        return Promise.all(uploadPromises);

                    case 7:
                        updatedFiles = _context2.sent;


                        setUploading(false);

                        setFiles(function (prevFiles) {
                            return prevFiles.map(function (fileObj) {
                                var updatedFile = updatedFiles.find(function (uf) {
                                    return uf.data === fileObj.data;
                                });
                                return updatedFile || fileObj;
                            });
                        });

                        if (onFilesChange) onFilesChange(files);

                    case 11:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    })), [config.uploadEndpoint, files]);

    var handleDelete = (0, _react.useCallback)(function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, fileId) {
            var response;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            e.stopPropagation();

                            _context3.prev = 1;
                            _context3.next = 4;
                            return _axios2.default.delete(config.uploadEndpoint + '/' + fileId, {
                                headers: {
                                    'Authorization': 'Bearer ' + restProps.session.authenticationToken.token
                                }
                            });

                        case 4:
                            response = _context3.sent;


                            if (response.status === 200 && response.data.operation.status) {
                                setFiles(function (prevFiles) {
                                    return prevFiles.filter(function (file) {
                                        return file.fileGuid !== fileId;
                                    });
                                });

                                if (onFilesChange) {
                                    onFilesChange(files.filter(function (file) {
                                        return file.fileGuid !== fileId;
                                    }));
                                }

                                if (onFileDelete) {
                                    onFileDelete(fileId);
                                }
                            }
                            _context3.next = 11;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](1);

                            console.error('Error deleting file:', _context3.t0);

                        case 11:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, undefined, [[1, 8]]);
        }));

        return function (_x3, _x4) {
            return _ref4.apply(this, arguments);
        };
    }(), [config.uploadEndpoint]);

    var handleDownload = (0, _react.useCallback)(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, fileUrl, fileName) {
            var response, blob, url, a;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            e.stopPropagation();

                            _context4.prev = 1;
                            _context4.next = 4;
                            return fetch(fileUrl);

                        case 4:
                            response = _context4.sent;
                            _context4.next = 7;
                            return response.blob();

                        case 7:
                            blob = _context4.sent;
                            url = window.URL.createObjectURL(blob);
                            a = document.createElement('a');

                            a.style.display = 'none';
                            a.href = url;
                            a.download = fileName || 'file';

                            document.body.appendChild(a);
                            a.click();

                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);
                            _context4.next = 22;
                            break;

                        case 19:
                            _context4.prev = 19;
                            _context4.t0 = _context4['catch'](1);

                            console.error('Error downloading the file:', _context4.t0);

                        case 22:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, undefined, [[1, 19]]);
        }));

        return function (_x5, _x6, _x7) {
            return _ref5.apply(this, arguments);
        };
    }(), []);

    var handleCancelUpload = (0, _react.useCallback)(function (fileName) {
        var fileToCancel = files.find(function (f) {
            return f.fileName === fileName;
        });
        if (fileToCancel && fileToCancel.cancelSource) {
            fileToCancel.cancelSource.cancel('Upload was canceled by the user.');

            setFiles(function (prevFiles) {
                return prevFiles.filter(function (file) {
                    return file.fileName !== fileName;
                });
            });

            if (onFilesChange) onFilesChange(files.filter(function (file) {
                return file.fileName !== fileName;
            }));
        }
    }, []);

    var removeFile = (0, _react.useCallback)(function (e, file) {
        e.stopPropagation();

        setFiles(function (prevFiles) {
            return prevFiles.filter(function (f) {
                return f.fileName !== file.fileName;
            });
        });

        if (onFilesChange) onFilesChange(files.filter(function (f) {
            return f.fileName !== file.fileName;
        }));

        // Reset the file input element
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, []);

    var getFileExtension = (0, _react.useCallback)(function (fileName) {
        return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2).toUpperCase();
    }, []);

    var allFilesUploaded = files.every(function (file) {
        return file.fileUrl || file.hasError;
    });

    return _react2.default.createElement(
        DropzoneContainer,
        _extends({}, getRootProps(), { isDragActive: isDragActive, config: config }),
        _react2.default.createElement('input', _extends({}, getInputProps(), {
            ref: fileInputRef
        })),
        _react2.default.createElement(_secondaryButton2.default, {
            clickEvent: handleAddFileClick,
            text: config.addFileButtonText || defaultAddFileButtonText
        }),
        _react2.default.createElement(_label2.default, {
            textAlign: _alignments.Alignments.center,
            text: config.dropzoneText || defaultDropzoneText
        }),
        files.length > 0 && _react2.default.createElement(
            FilesListContainer,
            null,
            files.map(function (file, index) {
                var isImage = file.contentType.startsWith('image/');
                var fileExtension = getFileExtension(file.fileName);
                var thumbnailUrl = file.thumbnailUrl;
                var isError = file.hasError;
                var errorDescription = isError ? file.errorDescription : '';

                return _react2.default.createElement(
                    _container2.default,
                    { key: index },
                    _react2.default.createElement(
                        FileItem,
                        { isError: isError },
                        _react2.default.createElement(
                            _container2.default,
                            { inline: true, verticalAlignment: _alignments.Alignments.center },
                            config.showPreview && (!isImage ? _react2.default.createElement(
                                FileThumbnail,
                                { config: config },
                                '.' + fileExtension
                            ) : thumbnailUrl ? _react2.default.createElement(ImageThumbnail, { src: thumbnailUrl,
                                alt: file.fileName
                            }) : _react2.default.createElement(PictureIcon, null)),
                            config.fileNameDisplay && _react2.default.createElement(_label2.default, { right: _sizes.Sizes.xs,
                                text: file.fileName
                            })
                        ),
                        _react2.default.createElement(
                            _container2.default,
                            { verticalAlignment: _alignments.Alignments.center, inline: true },
                            !file.fileUrl && !isError && config.progressDisplay && uploading && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(StyledProgress, { value: file.progress,
                                    max: '100',
                                    primaryColor: config.accentColor
                                }),
                                file.progress < 100 && _react2.default.createElement(
                                    IconBase,
                                    { onClick: function onClick() {
                                            return handleCancelUpload(file.fileName);
                                        } },
                                    _react2.default.createElement(_closeButton2.default, null)
                                )
                            ),
                            file.fileUrl && _react2.default.createElement(
                                FileActionContainer,
                                null,
                                _react2.default.createElement(
                                    IconBase,
                                    { onClick: function onClick(e) {
                                            return handleDelete(e, file.fileGuid);
                                        } },
                                    _react2.default.createElement(_delete2.default, null)
                                ),
                                _react2.default.createElement(
                                    IconBase,
                                    {
                                        onClick: function onClick(e) {
                                            return handleDownload(e, file.fileUrl, file.fileName);
                                        }
                                    },
                                    _react2.default.createElement(_download2.default, null)
                                )
                            ),
                            !file.fileUrl && !config.autoUpload && !uploading && _react2.default.createElement(_secondaryButton2.default, {
                                clickEvent: function clickEvent(e) {
                                    return removeFile(e, file);
                                },
                                text: defaultRemoveText
                            })
                        )
                    ),
                    isError && _react2.default.createElement(_errorLabel2.default, { text: errorDescription,
                        textAlign: _alignments.Alignments.left
                    })
                );
            })
        ),
        !config.autoupload && !allFilesUploaded && _react2.default.createElement(_primaryButton2.default, {
            text: defaultUploadButtonText,
            clickEvent: function clickEvent(e) {
                e.stopPropagation();
                handleUpload(files);
            }
        })
    );
};

FileUploader.defaultProps = {
    defaultConfig: {
        multiple: true,
        maxFiles: 0,
        maxSize: 'Infinity',
        showPreview: true,
        fileNameDisplay: true,
        progressDisplay: true,
        allowCancel: true,
        allowDownload: true,
        allowDelete: true,
        textColor: _colors.Colors.PrimaryText,
        accentColor: _colors.Colors.Primary,
        backgroundColor: 'whitesmoke'
    }
};

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    session: (0, _selectSession.selectSession)()
});

var FileUploaderWithIntl = (0, _reactIntl.injectIntl)(FileUploader);
exports.default = (0, _reactRedux.connect)(mapStateToProps)(FileUploaderWithIntl);